import { getURLParameter } from "../../../../lib/html5-software-library/src/ranj/util/URLUtil";
import Task from "../../../../lib/html5-software-library/src/ranj/util/executor/Task";
import Config from "../../app/config/Config";
import AppModel from "../../app/core/AppModel";
import PlatformAPICommand from "./PlatformAPICommand";
import PlatformAPIEventType from "./PlatformAPIEventType";
import PlatformAPIService from "./PlatformAPIService";
import AppPlatformParameters from "./AppPlatformParameters";
import MockApi from "./MockAPI";
import BaseSaveModel from "../savegame/BaseSaveModel";

export default class InitPlatformAPIServiceTask extends Task {

    /**
     * @param {Config} config 
     * @param {infuse.Injector} injector 
     * @param {soma.Commands} commands 
     * @param {AppModel} appModel
     * @param {BaseSaveModel} saveModel
     */
    constructor(config, injector, commands, appModel, saveModel) {
        super();

        this._config = config;
        this._injector = injector;
        this._commands = commands;
        this._appModel = appModel;
        this._saveModel = saveModel;
    }

    execute(callback) {
        const version = this._config.getValue(Config.VERSION);
        const appId = this._config.getValue(Config.APPID);
        const useMockApi = this._config.getValue(Config.USE_MOCK_API);

        this._injector.mapClass("platformAPIService", this.PLATFORM_API_SERVICE_TYPE, true);

        const isMockAPI = getURLParameter("mockapi") === "1" || useMockApi;
        if (isMockAPI) {
            console.info("[InitPlatformAPIServiceTask] Using MockAPI.");
            this._injector.mapClass("mockAPI", this.MOCK_API_TYPE, true);
            // initialize MockAPI
            this._injector.getValue("mockAPI").initialize();
        }

        this._commands.add(PlatformAPIEventType.INTERACTION, PlatformAPICommand);
        this._commands.add(PlatformAPIEventType.PROGRESS, PlatformAPICommand);
        this._commands.add(PlatformAPIEventType.SAVE_REQUEST, PlatformAPICommand);

        /**@type {PlatformAPIService} */
        const platformAPIService = this._injector.getValue("platformAPIService");
        platformAPIService.enableLogging(getURLParameter("logapi") == "1");

        this._initializeService(platformAPIService, appId, version)
            .finally(_ => {
                console.log(`InitPlatformAPIServiceTask completed.`);
                callback(this);
            });
    };

    /**
     * @param {PlatformAPIService} platformAPIService
     * @param {string} appId 
     * @param {string} version 
     */
    async _initializeService(platformAPIService, appId, version) {
        await platformAPIService.initialize(version);
        const parameters = await platformAPIService.getConfigurationAsync(appId);
        platformAPIService.setAppId(appId);
        this._applyPlatformConfiguration(parameters);
        platformAPIService.resumeProgress();
    }

    /**
     * Applies platform configuration/ parameters to game models.
     * @param {AppPlatformParameters} platformParameters 
     */
    _applyPlatformConfiguration(platformParameters) {
        this._appModel.language = getURLParameter("lang") ?? platformParameters.language;
        this._appModel.playMode = getURLParameter("mode") ?? platformParameters.playMode;
        this._appModel.environment = platformParameters.environment;

        this._saveModel.setSaveGame(getURLParameter("clear") === "1" ? null : platformParameters.state);
    };

    MOCK_API_TYPE = MockApi;
    PLATFORM_API_SERVICE_TYPE = PlatformAPIService;
}